<script>
    import { onMount } from 'svelte';
    import { appSettings } from "../stores";
    import Thumbnail from "../components/orte/Thumbnail.svelte";
    import { orte } from "../stores";

    onMount ( () => {
        $appSettings.currentPageLink = "/orte";
        $appSettings.currentPageName = "Orte";
        $appSettings.parentPage = "/";
        window.scrollTo(0, 0);
    })
</script>

<h1>Orte der Deportationen</h1>
<p>Die unten aufgelisteten Adressen sind die letzten Meldeadressen der aus Trier deportierten Jüdinnen und Juden. Nicht immer ist dieser letzte Wohnort vor der Deportation selbst gewählt worden. Einige der Adressen waren auch sogenannte „Judenhäuser“. In diese Häuser aus jüdischem Besitz wurden Jüdinnen und Juden zwangsweise eingewiesen. Ab Herbst 1939 begann die Geheime Staatspolizei (Gestapo) diese Zwangsunterbringung der kennzeichnungspflichtigen Juden durchzuführen, um Wohnraum für die „arische“ Bevölkerung zu schaffen.</p>
{#each orte as ort, i}
    <Thumbnail {...ort} />
    <br>
{/each}
<p>Vom Bahnhof der Stadt Trier aus fuhren fünf Deportationszüge Richtung Osten, deren Zielorte die Ghettos in Litzmannstadt (Łódź/heute: Polen) und Theresienstadt (Terezín/h: Tschechien) sowie das Vernichtungslager Belzec (Bełżec/h: Polen) und das Konzentrations- und Vernichtungslager Auschwitz(-Birkenau) (Oświęcim/h: Polen) waren. Vier weitere Sammeltransporte nach Theresienstadt und Auschwitz waren ebenfalls mit Triererinnen und Trierern besetzt. Im Vorfeld der Deportationen wurden die ausgewählten Jüdinnen und Juden gezwungen, ihre Habseligkeiten zu packen und sich mit Gepäck am Bischof-Korum-Haus (Rindertanzstr.) einzufinden um von dort aus mit selbst gekauften Fahrkarten die Bahnfahrt nach Osten anzutreten. Für die Abwicklung der Deportationen waren die Gestapo und die Städtische Polizei zuständig – die Abwicklung der Vermögensentziehung und der Versteigerung der nach der Deportation freigewordenen Immobilien samt Mobiliar lief über das städtische Finanzamt.</p>

<style>

</style>